// extracted by mini-css-extract-plugin
export var backgroundImage = "SkillsOverviewCardRight-module--backgroundImage--41323";
export var content = "SkillsOverviewCardRight-module--content--57940";
export var contentWrapper = "SkillsOverviewCardRight-module--contentWrapper--9bace";
export var mainTitle = "SkillsOverviewCardRight-module--mainTitle--006ad";
export var mainTitleContainer = "SkillsOverviewCardRight-module--mainTitleContainer--aa27b";
export var subTitle = "SkillsOverviewCardRight-module--subTitle--9db6d";
export var textContent = "SkillsOverviewCardRight-module--textContent--a1eb7";
export var title = "SkillsOverviewCardRight-module--title--c4c7f";
export var wrapper = "SkillsOverviewCardRight-module--wrapper--09ec8";